import api from '../api';

function add(formData) {
  formData = formData || {};

  return new Promise((resolve, reject) => {
    return api({
      method: 'post',
      url: '/customer/operational-documents',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(response => resolve(response))
    .catch(error => reject(error));
  });
}

function findAll(customerId) {
  return new Promise((resolve, reject) => {
    return api.get(`/customer/${customerId}/operational-documents`)
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}

function remove(documentId) {
  documentId = documentId || {};

  return new Promise((resolve, reject) => {
    return api.delete(`/customer/operational-documents/${documentId}`)
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}

function download(documentId){
  return  new Promise((resolve, reject) =>{
    return api.get('/customer/operational-documents/'+ documentId + '/download', { responseType: 'blob' })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}

export default {
  findAll,
  remove,
  add,
  download,
};